import Vue from "vue/dist/vue.js";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

import system from "./modules/system";

import calculator from "@/storage/modules/calculator";
import credit from "@/storage/modules/credit";
import current from "@/storage/modules/current";
import profile from '@/storage/modules/profile'

import leadForm from "./site/lead-form";
import faq from "./site/faq";

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
          'calculator.amount',
          'calculator.term',
          'calculator.creditType',
      ]
    })
  ],
  modules: {
    system,
    calculator,
    credit,
    current,
    leadForm,
    faq,
    profile
  }
});

export default store;
